import { HttpClient } from '#client/http/index'
import {
  AuthUser,
  RegisterParams,
  ResendEmailParams,
  EmailVerificationKey,
  VerifyEmailParams,
  ResetPasswordParams,
  DeregisterQuestion,
  DeregisterParams,
} from '#client/resources/index'
import { ApiResponse } from '#client/resources/types'

export const get = async ({ httpClient }: { httpClient: HttpClient }) => {
  const { data }: ApiResponse<AuthUser> = await httpClient.get('/auth/user')
  return data
}

export const login = async (
  { httpClient }: { httpClient: HttpClient },
  email: string,
  password: string,
  remember: 0 | 1 = 1,
) => {
  const { data }: ApiResponse<AuthUser> = await httpClient.post(
    '/auth/user/login',
    {
      email,
      password,
      remember,
    },
  )
  return data
}

export const logout = async ({ httpClient }: { httpClient: HttpClient }) => {
  await httpClient.delete('/auth/user/logout')
}

export const register = async (
  { httpClient }: { httpClient: HttpClient },
  {
    email,
    password,
    passwordConfirmation,
    campaignCode,
    optIns,
    referralSubjectCode,
    socialSignupToken,
    utmSource,
    utmMedium,
    utmCampaign,
    intended,
  }: RegisterParams,
) => {
  const { data }: ApiResponse<AuthUser> = await httpClient.post(
    '/auth/user/register',
    {
      email,
      password,
      password_confirmation: passwordConfirmation,
      campaignCode,
      optIns,
      referralSubjectCode: referralSubjectCode ?? null,
      socialSignupToken: socialSignupToken ?? null,
      utmSource,
      utmMedium,
      utmCampaign,
      intended,
    },
  )
  return data
}

export const resendEmail = async (
  { httpClient }: { httpClient: HttpClient },
  params?: ResendEmailParams,
) => {
  return await httpClient.post('/auth/user/email/resend', params)
}

export const verifyEmail = async (
  { httpClient }: { httpClient: HttpClient },
  verificationKey: EmailVerificationKey,
  params: VerifyEmailParams,
) => {
  return await httpClient.get(`/auth/user/email/verify/${verificationKey}`, {
    params,
  })
}

export const passwordResetEmail = async (
  { httpClient }: { httpClient: HttpClient },
  email: string,
) => {
  return await httpClient.post(`/auth/user/password/email`, { email })
}

export const passwordReset = async (
  { httpClient }: { httpClient: HttpClient },
  params: ResetPasswordParams,
) => {
  return await httpClient.post(`/auth/user/password/reset`, {
    ...params,
    password_confirmation: params.passwordConfirmation,
  })
}

export const listDeregisterQuestions = async ({
  httpClient,
}: {
  httpClient: HttpClient
}) => {
  const { data } = await httpClient.get<DeregisterQuestion[]>(
    '/auth/user/deregister/questions',
  )
  return data
}

export const deregister = async (
  { httpClient }: { httpClient: HttpClient },
  params: DeregisterParams,
) => {
  return await httpClient.post('/auth/user/deregister', params)
}

export const directUserAuthForSocialLogin = async (
  { httpClient }: { httpClient: HttpClient },
  userSocialAuthenticationId: string,
  params: {
    expires: number
    signature: string
  },
) => {
  return await httpClient.get(
    `/user/direct_auth_for_social_login/${userSocialAuthenticationId}`,
    {
      params,
    },
  )
}
